import { Component } from '@angular/core';

@Component({
  selector: 'app-srdcorp-india-pvt-ltd',
  templateUrl: './srdcorp-india-pvt-ltd.component.html',
  styleUrls: ['./srdcorp-india-pvt-ltd.component.scss']
})
export class SrdcorpIndiaPvtLtdComponent {

}
